import Decimal from 'decimal.js';

export const ZERO_DECIMAL = new Decimal(0);
